import { route as ziggyRoute } from 'ziggy-js';

/**
 * Ziggy exposes Laravel's named routes to the front end.
 *
 * `@routes` in the Blade layout defines `window.Ziggy` before this module runs,
 * so binding the global here means components can call `route('complaints.store')`
 * without importing configuration everywhere.
 */
declare global {
    // eslint-disable-next-line no-var
    var Ziggy: Parameters<typeof ziggyRoute>[3];

    interface Window {
        route: typeof ziggyRoute;
    }
}

export const route = ((name?: string, params?: unknown, absolute?: boolean) =>
    ziggyRoute(name as never, params as never, absolute, globalThis.Ziggy)) as typeof ziggyRoute;

if (typeof window !== 'undefined') {
    window.route = route;
}
